export default "__VITE_PUBLIC_ASSET__1971f88b__"